import { getListCancellationReasons } from "../../data/repository/cancellationReasonRepo";

export const getListCancellationReasonsUseCase = async () => {
  return await getListCancellationReasons();
};
